export default defineNuxtPlugin((nuxtApp) => {
  const { setIsGigyaLoaded, checkGigyaAndC1Session } = useAuthService();
  const { bindGigyaLoadEvent, subscribeToGigyaLoaded } = useGigyaSession();

  nuxtApp.hook('app:mounted', () => {
    bindGigyaLoadEvent();
    /**
     * This is to handle the case where the user's backend session exipres and the page is refreshed.
     * In this case, we need to check if the user's Gigya session is valid.
     * If the Gigya session is valid, we need to fetch the user data from the session and login the user.
     * This is done only for the footer link of onboarding app and all routes of other apps.
     * */

    subscribeToGigyaLoaded(async () => {
      setIsGigyaLoaded(true);
      await checkGigyaAndC1Session();
    });
  });
});
